import {notificationSchema} from 'apis'
import {LoginContext} from 'components/LoginContext'
import {getTokenKey} from 'helpers/localStorage'
import {normalize, schema} from 'normalizr'
import React, {useContext, useEffect, useRef} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {authenticate, startRoom} from './actions'
import {createSocket} from './socket'
import {SocketContext} from './SocketContext'
import {AUTHENTICATED, CONNECT, JOINED_ROOM} from './types'

export const useEmit = () => {
  const {emit} = useContext(SocketContext)
  return emit
}
let _socket
export default function SocketProvider({children}) {
  const socket = useSelector((state) => state.socket)
  const login = useContext(LoginContext)
  const loginId = login && login.id
  const dispatch = useDispatch()
  const socketRef = useRef()
  useEffect(() => {
    if (loginId) {
      _socket = createSocket((_type, payload = {}, emit) => {
        // message.info(_type)
        const action = {
          type: 'socket/' + _type,
          socket: {
            type: _type,
            payload,
          },
        }
        switch (_type) {
          case CONNECT:
            const token = getTokenKey()
            if (token) {
              emit(
                authenticate({
                  token,
                })
              )
            }

            break
          case JOINED_ROOM:
            break
          case AUTHENTICATED:
            if (loginId) {
              emit(
                startRoom({
                  roomType: 'user',
                  roomId: loginId,
                })
              )
            }
            break
          case 'notifications':
            const record = {
              id: '/notifications/gets',
              news: [payload],
            }
            const {result, entities} = normalize(
              record,
              new schema.Entity(
                'records',
                {
                  news: [notificationSchema],
                },
                {
                  idAttribute: 'id',
                }
              )
            )
            action.entities = entities
            break
          default:
            break
        }
        dispatch(action)
      })
      socketRef.current = _socket

      if (!!socketRef.current?.socket) {
        socketRef.current.socket.off('system-notifications')
        socketRef.current.socket.on('system-notifications', (payload) => {
          if (!!payload?.id) {
            if (window.cordova && window.cordova.plugins && window.cordova.plugins.notification) {
              let notify = {...payload, foreground: true}
              if (!!notify.description) {
                notify.text = notify.description;
              }
              if (!!notify.repeat_every) {
                notify.trigger = {every: notify.repeat_every};
                if (!!notify.repeat_count) {
                  notify.trigger.count = notify.repeat_count;
                }
              } else if (!!notify.trigger_in && !!notify.trigger_unit) {
                notify.trigger = {in: notify.trigger_in, unit: notify.trigger_unit};
              } else if (!!notify.yyyy && !!notify.mm && !!notify.dd) {
                if (!!notify.yyyy && !!notify.mm && !!notify.dd) {
                  notify.trigger = {at: new Date(notify.yyyy, notify.mm, notify.dd)};
                } else if (!!notify.yyyy && !!notify.mm && !!notify.dd && !!notify.hh) {
                  notify.trigger = {at: new Date(notify.yyyy, notify.mm, notify.dd, notify.hh)};
                } else if (!!notify.yyyy && !!notify.mm && !!notify.dd && !!notify.hh && !!notify.mi) {
                  notify.trigger = {at: new Date(notify.yyyy, notify.mm, notify.dd, notify.hh, notify.mi)};
                } else if (!!notify.yyyy && !!notify.mm && !!notify.dd && !!notify.hh && !!notify.mi && !!notify.ss) {
                  notify.trigger = {at: new Date(notify.yyyy, notify.mm, notify.dd, notify.hh, notify.mi, notify.ss)};
                }
              } else {
                notify.trigger = notify.params;
              }
              window.cordova.plugins.notification.local.schedule(notify);
            }
          }
        })
      }
    }

    return () => socketRef.current && socketRef.current.socket.disconnect()
  }, [dispatch, loginId])

  return (
    <SocketContext.Provider
      value={{
        ...socket,
        ...socketRef.current,
      }}>
      {children}
    </SocketContext.Provider>
  )
}
